// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3463) return "static/chunks/3463-bf340c157c1bb077.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "736b814dea054021" + ".js";
};